import { render, staticRenderFns } from "./SelectorRequestWarranty.vue?vue&type=template&id=4459e106&"
import script from "./SelectorRequestWarranty.vue?vue&type=script&lang=ts&"
export * from "./SelectorRequestWarranty.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorRequestWarranty.vue?vue&type=style&index=0&id=4459e106&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports